import { render, staticRenderFns } from "./CharLeft.vue?vue&type=template&id=109f033d&"
import script from "./CharLeft.vue?vue&type=script&lang=js&"
export * from "./CharLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports